<template>
  <div class="question-response-bars is-flex-col gap-1">
    <div
      v-if="label"
      class="is-flex"
    >
      <div
        class="has-text-right underlined"
        :style="{ 'flex-basis': '3rem' }"
      >
        {{ label }}
      </div>
    </div>

    <div
      v-for="row in displayDataSorted"
      :key="row.choice"
      class="is-flex gap-1-2"
    >
      <div
        class="bold has-text-right"
        :style="{ 'flex-basis': '3rem' }"
      >
        {{ row.label ? row.label : row.pct.toFixed(0) + '%' }}
      </div>

      <div class="grow">
        <div class="is-relative">
          <progress
            class="progress is-large is-success mb-0"
            :value="(row.pct / 100)"
          />

          <span
            class="is-absolute has-text-white px-2 bold"
            :style="{ top: 0 }"
          >
            {{ row.choice }}
          </span>
        </div>
      </div>

      <div
        class="is-flex flex-wrap gap-1-4"
        :style="{ 'flex-basis': '20rem' }"
      >
        <div
          v-for="name in row.names"
          :key="name"
          class="is-flex-center is-size-7 mr-1"
        >
          <i
            class="fa fa-circle mr-1"
            :style="{ 'font-size': '0.6rem', color: assignedColors[name] }"
          />
          <span>{{ name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'


export default {
  name: 'QuestionResponseBars',
  components: { /* Subcomponents */ },
  props: ['displayData', 'assignedColors', 'label'],
  data() {
    return { /* Local variables */ };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    startColor() {
      return this.$root.$data.COLORS.accent.green[3];
    },
    endColor() {
      return this.$root.$data.COLORS.gray[4];
    },
    displayDataSorted() {
      const data = [...this.displayData];
      return data.sort((a, b) => b.pct - a.pct);
    },
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {
    console.table(this.displayData);
  },
  mounted() {},
  updated() {},
  methods: {},
};
</script>


<style scoped>

</style>
